import { useEffect, useState } from "react";

import { matchGeoFirstAndLastCoords, useGetFieldShape } from "utils";

import { FieldShape } from "models";

export const useFieldGeometry = (fieldId: string) => {
  const [geometry, setGeometry] = useState<FieldShape | null>(null);
  const { fieldShape, fieldShapeLoading } = useGetFieldShape({ fieldId });

  useEffect(() => {
    if (fieldShape && !geometry) {
      setGeometry({ ...fieldShape, geometry: matchGeoFirstAndLastCoords(fieldShape.geometry) });
    }
  }, [fieldShape]); // eslint-disable-line react-hooks/exhaustive-deps

  return { geometry, geometryLoading: fieldShapeLoading };
};
